var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var getIterator = require('get-iterator');

var toIterable = require('pull-stream-to-async-iterator');

function toPull(source) {
  source = getIterator(source);
  return function _callee(end, cb) {
    var next;
    return _regeneratorRuntime.async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!end) {
              _context.next = 11;
              break;
            }

            if (!source.return) {
              _context.next = 10;
              break;
            }

            _context.prev = 2;
            _context.next = 5;
            return _regeneratorRuntime.awrap(source.return());

          case 5:
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", cb(_context.t0));

          case 10:
            return _context.abrupt("return", cb(end));

          case 11:
            _context.prev = 11;
            _context.next = 14;
            return _regeneratorRuntime.awrap(source.next());

          case 14:
            next = _context.sent;
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t1 = _context["catch"](11);
            return _context.abrupt("return", cb(_context.t1));

          case 20:
            if (!next.done) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", cb(true));

          case 22:
            // eslint-disable-line
            cb(null, next.value);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, [[2, 7], [11, 17]]);
  };
}

toPull.source = toPull;

toPull.transform = toPull.through = function (source) {
  return function (read) {
    return toPull(source(toIterable(read)));
  };
};

toPull.duplex = function (duplex) {
  return {
    sink: toPull.sink(duplex.sink),
    source: toPull(duplex.source)
  };
};

toPull.sink = function (sink) {
  return function (read) {
    var _sink;

    sink((_sink = {}, _defineProperty(_sink, Symbol.asyncIterator, function () {
      return this;
    }), _defineProperty(_sink, "next", function next() {
      return new Promise(function (resolve, reject) {
        read(null, function (end, value) {
          if (end === true) return resolve({
            done: true,
            value: value
          });
          if (end) return reject(end);
          resolve({
            done: false,
            value: value
          });
        });
      });
    }), _defineProperty(_sink, "return", function _return() {
      return new Promise(function (resolve, reject) {
        read(true, function (end, value) {
          if (end && end !== true) return reject(end);
          resolve({
            done: true,
            value: value
          });
        });
      });
    }), _defineProperty(_sink, "throw", function _throw(err) {
      return new Promise(function (resolve, reject) {
        read(err, function (end, value) {
          if (end && end !== true) return reject(end);
          resolve({
            done: true,
            value: value
          });
        });
      });
    }), _sink));
  };
};

module.exports = toPull;